import { Text } from '@billda/design-system';

interface VersionInfoProps {
  variant?: 'default' | 'compact';
}

/**
 * Displays the application version (DS fork of shared-ui VersionInfo).
 * Uses the VITE_APP_VERSION environment variable injected at build time by
 * vite.config.ts.
 */
export function VersionInfo({ variant = 'default' }: VersionInfoProps) {
  const version = import.meta.env.VITE_APP_VERSION || 'unknown';

  if (variant === 'compact') {
    return (
      <Text variant="caption" color="secondary">
        v{version}
      </Text>
    );
  }

  return (
    <Text variant="body2" color="secondary">
      Version: {version}
    </Text>
  );
}
